export const MINIMUM_SUPPORTED_VERSION = '4.4.0';
